export default __webpack_public_path__ + "static/media/question-icon.96b43f09.svg";